import { create } from 'zustand';
import { ApiUtils, MessageEntity, MessagesApi, RequestStrategyEnum } from '@shared/api';

interface ISendMessageStore {
  loading: boolean;
  error: string | null;
  sendMessage: (message: MessageEntity, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSendMessageStore = create<ISendMessageStore>((set) => ({
  loading: false,
  error: null,

  sendMessage: ApiUtils.wrapperApi(async (message: MessageEntity, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await MessagesApi.sendMessage(message, signal);
      set({ loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
